export const getDatesOfThisWeek = (days = [], time = "00:00") => {
  const today = new Date();
  const currentDay = today.getDay(); // 0 (Sunday) to 6 (Saturday)

  return days.reduce((arr, cur) => {
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - currentDay);
    const targetDayOfWeek = cur % 7;
    const targetDate = new Date(startOfWeek);
    targetDate.setDate(startOfWeek.getDate() + targetDayOfWeek);
    arr.push(`${targetDate.toISOString().split("T")[0]} ${time}:00`);
    return arr;
  }, []);
};
